import React, { useEffect } from 'react';
import {
  Calendar,
  Clock,
  Wifi,
  User,
  Building2,
  CreditCard,
  Users,
  Map,
  FileText,
  Landmark,
  PiggyBank,
  Briefcase,
  ShieldCheck,
  Route,
  Target,
  BookOpen,
  Megaphone,
  TrendingUp,
  HandCoins,
  Handshake,
  MessageSquare,
  LayoutList,
  AlertTriangle,
  Compass,
  PenLine,
  Share2,
  Lightbulb
} from 'lucide-react';
import styles from '../ReceptionistComponents/syllabus/Syllabus.module.css';
import ScrollReveal from 'scrollreveal';

const AdminSyllabus = ({ bgImage }) => {

  useEffect(() => {
    ScrollReveal().reveal(`.${styles.dayCard}`, {
      duration: 1000,
      distance: '50px',
      origin: 'bottom',
      easing: 'ease-out',
      reset: false,
      viewFactor: 0.2,
      interval: 200,
    });
  }, []);

  const sessions = [
    {
      number: 1,
      title: 'זהות מקצועית ותפיסת תפקיד',
      icon: User,
      bgImage: bgImage,
      points: [
        { text: 'היכרות עם תחום ניהול האדמיניסטרציה', icon: Building2 },
        { text: 'הבדלים בין מזכירה למנהלת אדמיניסטרציה', icon: Target },
        { text: 'הגדרת אחריות וגבולות, בניית זהות אישית', icon: ShieldCheck },
        { text: 'הבנה של סוגי העצמאים והעסקים בארץ ומיפוי לפי קטגוריות', icon: LayoutList },
        { text: 'סוגי השירותים שניתן לספק', icon: Briefcase }
      ]
    },
    {
      number: 2,
      title: 'תשתיות העסק וניהול פיננסי חכם',
      icon: Landmark,
      bgImage: bgImage,
      points: [
        { text: 'סוגי התאגדות ואחריות בעל העסק מול מנהלת המשרד', icon: FileText },
        { text: 'תרגול מפת יסודות העסק', icon: Map },
        { text: 'מסגרת חוקית ופיננסית של עצמאים, פתיחת תיקים ברשויות', icon: Landmark },
        { text: 'איך הבנק רואה עסק עצמאי, עקרונות לניהול תזרים נכון', icon: PiggyBank }
      ]
    },
    {
      number: 3,
      title: 'תמחור, רווחיות וניהול כספי, קליטת לקוח וניהול שוטף',
      icon: CreditCard,
      bgImage: bgImage,
      points: [
        { text: 'הקשר בין שעות עבודה לתמחור, הוצאות והכנסות', icon: HandCoins },
        { text: 'בחירת מודל תמחור ובסיס לרווחיות', icon: TrendingUp },
        { text: 'סדר יום, ניהול שוטף, דגשים להסכם מול לקוח', icon: Handshake },
        { text: 'בניית תהליך קליטת לקוח מסודר', icon: Users },
        { text: 'הגדרת גבולות עבודה, זמינות ותקשורת', icon: MessageSquare },
        { text: 'זיהוי נורות אזהרה וניהול עומסים', icon: AlertTriangle }
      ]
    },
    {
      number: 4,
      title: 'שיווק ומכירות - פיתוח מיינדסט שיווקי',
      icon: Megaphone,
      bgImage: bgImage,
      points: [
        { text: 'כללי זהב להתנהלות ברשתות', icon: Share2 },
        { text: 'סדנת מכירות למנהלות משרד', icon: Handshake },
        { text: 'איך להגדיר את עצמי במדיה ולהציג את השירות ללקוח', icon: PenLine },
        { text: 'איך לפרסם ברשתות, איזה תוכן עובד ואיך לבנות קמפיין', icon: Lightbulb }
      ]
    },
    {
      number: 5,
      title: 'הגנה על העתיד, מפת דרכים ויציאה לדרך',
      icon: Route,
      bgImage: bgImage,
      points: [
        { text: 'סיכום התהליך האישי והמקצועי', icon: BookOpen },
        { text: 'בניית מפת דרכים להמשך', icon: Compass },
        { text: 'דיוק צעדים ראשונים ליציאה לשוק או שדרוג עבודה קיימת', icon: Target },
        { text: 'תכנון והבנה של התנהלות פיננסית כעצמאית', icon: PiggyBank }
      ]
    }
  ];

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <h1 className={styles.title}>הכשרה וליווי באונליין לפתיחת עסק בתחום האדמיניסטרציה</h1>
        </div>

        <div className={styles.infoGrid}>
          <div className={styles.infoCard}>
            <div className={styles.infoIcon}>
              <Calendar size={22} color="#FFFFFF" />
            </div>
            <div className={styles.infoText}>5 מפגשים | ימי שישי 09:00-11:00</div>
          </div>

          <div className={styles.infoCard}>
            <div className={styles.infoIcon}>
              <Clock size={22} color="#FFFFFF" />
            </div>
            <div className={styles.infoText}>19/6 | 26/6 | 3/7 | 10/7 | 17/7</div>
          </div>

          <div className={styles.infoCard}>
            <div className={styles.infoIcon}>
              <Wifi size={22} color="#FFFFFF" />
            </div>
            <div className={styles.infoText}>ההכשרה באונליין</div>
          </div>
        </div>

        <div className={styles.daysContainer}>
          {sessions.map((session, sessionIndex) => {
            const SessionIcon = session.icon;
            return (
              <div
                key={sessionIndex}
                className={styles.dayCard}
                style={session.bgImage ? { '--bg-image': session.bgImage } : {}}
              >
                <div className={styles.dayHeader}>
                  <div className={styles.dayNumber}>{String(session.number).padStart(2, '0')}</div>
                  <h2 className={styles.dayTitle}>{session.title}</h2>
                </div>

                <div className={styles.itemList}>
                  {session.points.map((point, pointIndex) => {
                    const PointIcon = point.icon;
                    return (
                      <div key={pointIndex} className={styles.item}>
                        <div className={styles.itemIcon}>
                          <PointIcon className={styles.lucideIcon} />
                        </div>
                        <div className={styles.itemText}>{point.text}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AdminSyllabus;
